import * as Yup from "yup";
import { Link } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { Col, Container, Row, CardBody, Card } from "reactstrap";
import {
  Form,
  Label,
  Modal,
  Input,
  Button,
  ModalBody,
  FormGroup,
  ModalFooter,
  ModalHeader,
  FormFeedback,
  Toast,
  ToastHeader,
  ToastBody,
} from "reactstrap";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { AppDispatch } from "src";
import { useDispatch, useSelector } from "react-redux";
import {
  changePassword,
  getUserById,
  getUsers,
  updateUser,
} from "src/slices/User/thunk";

const UsertSetting = () => {
  document.title = "Perfil | Khozi";
  const [modalPassword, setModalPassword] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<boolean>(false);
  const user = useSelector((state: any) => state.users.user);
  const users = useSelector((state: any) =>
    state.users.users.filter((user: any) => user.id !== 1)
  );
  const superior = useSelector((state: any) =>
    state.users.users.find((u: any) => u.id === user?.supervisor_id)
  );
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    const user = localStorage.getItem("authUser");

    if (user) {
      const obj = JSON.parse(user);
      if (obj.user_id) {
        dispatch(getUserById(obj.user_id));
      }
    }
  }, []);

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState<string>("");

  const passwordValidation = useFormik({
    enableReinitialize: true,

    initialValues: {
      old_password: "",
      new_password1: "",
      new_password2: "",
    },
    validationSchema: Yup.object({
      old_password: Yup.string().required(
        "Por favor, insira a palavra-passe antiga"
      ),
      new_password1: Yup.string()
        .required("Por favor, insira a palavra-passe nova")
        .min(8, "A palavra-passe deve conter pelo menos 8 caracteres.")
        .notOneOf(
          [user?.username, user?.first_name, user?.last_name, user?.email],
          "A palavra-passe não pode ser muito semelhante às suas outras informações pessoais."
        )
        // .notOneOf(
        //   ["12345678", "password", "123456789", "1234567", "123456"],
        //   "A palavra-passe não pode ser uma palavra-passe comumente usada."
        // )
        .matches(
          /^(?![0-9]*$)/,
          "A palavra-passe não pode ser inteiramente numérica."
        ),
      new_password2: Yup.string()
        .oneOf(
          [Yup.ref("new_password1"), undefined],
          "As senhas devem coincidir"
        )
        .required("Por favor, confirme a palavra-passe nova"),
    }),
    onSubmit: values => {
      dispatch(changePassword(values)).then((response: any) => {
        setToastMessage(response.payload);
        togglePassword();
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000); // Hide toast after 3 seconds
      });
    },
  });

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      username: `${user?.username}`,
      first_name: `${user?.first_name}`,
      last_name: `${user?.last_name}`,
      email: `${user?.email}`,
      telephone: `${user?.telephone.replace(/^\+258/, "")}`,
      superior: user?.supervisor_id,
      role: `${user?.role}`,
      status: `${user?.status}`,
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Por favor, insira o nome de utilizador"),
      first_name: Yup.string().required("Por favor, insira o nome completo"),
      last_name: Yup.string().required("Por favor, insira o nome completo"),
      email: Yup.string().required("Por favor, insira o email"),
      telephone: Yup.string().required("Por favor, insira o telefone"),
      superior: Yup.number().nullable().optional(),
      role: Yup.string().required("Por favor, insira a função"),
      status: Yup.string().required("Por favor, insira o status"),
    }),
    onSubmit: values => {
      dispatch(updateUser({ ...values, id: user.id })).then(() => {
        dispatch(getUsers());
      });
    },
  });

  const togglePassword = () => {
    setModalPassword(!modalPassword);
  };

  const normalizeRole = (role: string | undefined): string => {
    switch (role) {
      case "AD":
        return "Administrador";
      case "EX":
        return "Executivo";
      case "OP":
        return "Planificador";
      default:
        return "-";
    }
  };

  const [showPasswords, setShowPasswords] = useState<{
    [key: string]: boolean;
  }>({
    old_password: false,
    new_password1: false,
    new_password2: false,
  });

  const togglePasswordVisibility = (field: string) => {
    setShowPasswords(prevState => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  if (!user) return null;

  return (
    <div className="page-content">
      <Container fluid>
        <Toast
          isOpen={showToast}
          className="position-fixed bottom-0 end-0 m-3 z-index-1000"
          style={{ zIndex: 1000 }}
        >
          <ToastHeader toggle={() => setShowToast(false)}>
            Password Changed
          </ToastHeader>
          <ToastBody>{toastMessage}</ToastBody>
        </Toast>

        <Breadcrumbs title="Khozi" breadcrumbItem="Perfil" />
        <Row>
          <Row className="col-xxl-3 col-lg-4">
            <Card>
              <CardBody>
                <div
                  className="profile-bg position-relative overflow-hidden rounded-top"
                  style={{ height: "150px" }}
                >
                  <div className="bg-overlay bg-dark bg-gradient"></div>

                  <div className="position-relative p-3 text-end">
                    <button type="button" className="btn btn-primary btn-sm">
                      <i className="mdi mdi-pencil me-1"></i> Edit
                    </button>
                  </div>
                </div>
                <div className="text-center">
                  <div className="position-relative d-inline-block mx-auto mt-n5 mb-4">
                    <div className="avatar-lg">
                      <img
                        src={user?.profile_pic || avatar1}
                        alt=""
                        className="rounded-circle img-thumbnail"
                      />
                    </div>
                    <Link
                      to="#"
                      className="d-block position-absolute bottom-0 end-0"
                    >
                      <div className="avatar-sm">
                        <div className="avatar-title rounded-circle bg-light text-primary">
                          <i className="mdi mdi-pencil"></i>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <h5 className="font-size-16 mb-1">{`${user?.first_name} ${user?.last_name}`}</h5>
                  <p className="text-muted mb-0">{normalizeRole(user?.role)}</p>
                </div>
                <hr className="my-4" />
                <div>
                  <h5 className="font-size-16">Informações</h5>

                  <div className="mt-4">
                    <p className="text-muted mb-1">Nome:</p>
                    <h5 className="font-size-14 text-truncate">{`${user?.first_name} ${user?.last_name}`}</h5>
                  </div>

                  <div className="mt-4">
                    <p className="text-muted mb-1">Email</p>
                    <h5 className="font-size-14 text-truncate">
                      {user?.email}
                    </h5>
                  </div>
                  <div className="mt-4">
                    <p className="text-muted mb-1">Superior</p>
                    <h5 className="font-size-14 text-truncate">
                      {superior
                        ? `${superior.first_name} ${superior.last_name}`
                        : "-"}
                    </h5>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Row>
          <div className="col-xxl-9 col-lg-8">
            <Card>
              <CardBody>
                <Form
                  className="needs-validation"
                  onSubmit={e => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <div className="card border shadow-none mb-5">
                    <div className="card-header d-flex align-items-center">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar-sm">
                          <div className="avatar-title rounded-circle btn-primary-subtle text-primary">
                            01
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="card-title">Utilizador</h5>
                      </div>
                    </div>
                    <CardBody>
                      <div>
                        <Row>
                          <Col>
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom01">
                                Nome de Utilizador
                              </Label>
                              <Input
                                name="username"
                                placeholder="Insira o nome de utilizador"
                                type="text"
                                className="form-control"
                                id="validationCustom01"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.username || ""}
                                invalid={
                                  validation.touched.username &&
                                  validation.errors.username
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.username &&
                              validation.errors.username ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.username}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6}>
                            <Button type="button" onClick={togglePassword}>
                              Mudar palavra-passe
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </CardBody>
                  </div>

                  <div className="card border shadow-none mb-5">
                    <div className="card-header d-flex align-items-center">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar-sm">
                          <div className="avatar-title rounded-circle btn-primary-subtle text-primary">
                            02
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="card-title">Informações de Perfil</h5>
                      </div>
                    </div>
                    <CardBody>
                      <Row>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="first_name">Nome</Label>
                            <Input
                              name="first_name"
                              placeholder="Nome"
                              type="text"
                              className="form-control"
                              id="first_name"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.first_name || ""}
                              invalid={
                                validation.touched.first_name &&
                                validation.errors.first_name
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.first_name &&
                            validation.errors.first_name ? (
                              <FormFeedback type="invalid">
                                {validation.errors.first_name}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="last_name">Sobrenome</Label>
                            <Input
                              name="last_name"
                              placeholder="Sobrenome"
                              type="text"
                              className="form-control"
                              id="last_name"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.last_name || ""}
                              invalid={
                                validation.touched.last_name &&
                                validation.errors.last_name
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.last_name &&
                            validation.errors.last_name ? (
                              <FormFeedback type="invalid">
                                {validation.errors.last_name}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="email">Email</Label>
                            <Input
                              name="email"
                              placeholder="Email"
                              type="text"
                              className="form-control"
                              id="email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={
                                validation.touched.email &&
                                validation.errors.email ? true : false
                              }
                            />
                            {validation.touched.email &&
                            validation.errors.email ? (
                              <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="telephone">Telefone</Label>
                            <div className="d-flex align-items-center">
                              <span className="me-2">+258</span>
                              <Input
                                name="telephone"
                                placeholder="Telefone"
                                type="text"
                                className="form-control"
                                id="telephone"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.telephone || ""}
                                invalid={
                                  validation.touched.telephone &&
                                  validation.errors.telephone ? true : false
                                }
                              />
                            </div>

                            {validation.touched.telephone &&
                            validation.errors.telephone ? (
                              <FormFeedback type="invalid">
                                {validation.errors.telephone}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                      </Row>
                      {user.role === "AD" && (
                        <>
                          <Row>
                            <Col md="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="superior">Superior</Label>
                                <Input
                                  name="superior"
                                  placeholder="Superior"
                                  type="select"
                                  id="superior"
                                  className="form-control"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.superior || ""}
                                  invalid={
                                    validation.touched.superior &&
                                    validation.errors.superior
                                      ? true
                                      : false
                                  }
                                >
                                  <option value="">Selecione</option>
                                  {users.map((user: any) => (
                                    <option value={user.id} key={user.id}>
                                      {user.first_name} {user.last_name}
                                    </option>
                                  ))}
                                </Input>
                              </FormGroup>
                            </Col>
                            <Col md="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="role">Função</Label>
                                <Input
                                  name="role"
                                  placeholder="Função"
                                  type="select"
                                  className="form-control"
                                  id="role"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.role || ""}
                                  invalid={
                                    validation.touched.role &&
                                    validation.errors.role
                                      ? true
                                      : false
                                  }
                                >
                                  <option value="">Selecione</option>
                                  <option value="AD">Administrador</option>
                                  <option value="EX">Executivo</option>
                                  <option value="OP">Planificador</option>
                                </Input>
                                {validation.touched.role &&
                                validation.errors.role ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.role}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="validationCustom05">
                                  Status
                                </Label>
                                <Input
                                  name="status"
                                  placeholder="Status"
                                  type="select"
                                  className="form-control"
                                  id="validationCustom05"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.status || ""}
                                  invalid={
                                    validation.touched.status &&
                                    validation.errors.status
                                      ? true
                                      : false
                                  }
                                >
                                  <option value="">Selecione</option>
                                  <option value="A">Ativo</option>
                                  <option value="I">Inativo</option>
                                  <option value="T">Temporario</option>
                                </Input>
                                {validation.touched.status &&
                                validation.errors.status ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.status}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      )}
                    </CardBody>
                  </div>

                  <div className="text-end">
                    <Button color="primary" type="submit">
                      Actualizar
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
        <Modal isOpen={modalPassword} toggle={togglePassword} centered={true}>
          <Form
            className="needs-validation"
            onSubmit={e => {
              e.preventDefault();
              passwordValidation.handleSubmit();
              return false;
            }}
          >
            <ModalHeader toggle={togglePassword} tag="h4">
              Mudar palavra-passe
            </ModalHeader>
            <ModalBody>
              <Row>
                <FormGroup
                  className="mb-3 position-relative"
                  style={{ position: "relative" }}
                >
                  <Label htmlFor="validationCustom01">
                    Palavra-passe antiga
                  </Label>
                  <Input
                    name="old_password"
                    placeholder="Insira a palavra-passe"
                    type={showPasswords.old_password ? "text" : "password"}
                    className="form-control"
                    id="old_password"
                    onChange={passwordValidation.handleChange}
                    onBlur={passwordValidation.handleBlur}
                    value={passwordValidation.values.old_password || ""}
                    invalid={
                      passwordValidation.touched.old_password &&
                      passwordValidation.errors.old_password
                        ? true
                        : false
                    }
                  />
                  <span
                    onClick={() => togglePasswordVisibility("old_password")}
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "37px",
                      cursor: "pointer",
                    }}
                  >
                    {showPasswords.old_password ? (
                      <i className="mdi mdi-eye-off"></i>
                    ) : (
                      <i className="mdi mdi-eye"></i>
                    )}
                  </span>
                  {passwordValidation.touched.old_password &&
                  passwordValidation.errors.old_password ? (
                    <FormFeedback type="invalid">
                      {passwordValidation.errors.old_password}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom01">Palavra-passe nova</Label>
                  <Input
                    name="new_password1"
                    placeholder="Insira a palavra-passe"
                    type={showPasswords.new_password1 ? "text" : "password"}
                    className="form-control"
                    id="new_password1"
                    onChange={passwordValidation.handleChange}
                    onBlur={passwordValidation.handleBlur}
                    value={passwordValidation.values.new_password1 || ""}
                    invalid={
                      passwordValidation.touched.new_password1 &&
                      passwordValidation.errors.new_password1
                        ? true
                        : false
                    }
                  />
                  <span
                    onClick={() => togglePasswordVisibility("new_password1")}
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "37px",
                      cursor: "pointer",
                    }}
                  >
                    {showPasswords.new_password1 ? (
                      <i className="mdi mdi-eye-off"></i>
                    ) : (
                      <i className="mdi mdi-eye"></i>
                    )}
                  </span>
                  {passwordValidation.touched.new_password1 &&
                  passwordValidation.errors.new_password1 ? (
                    <FormFeedback type="invalid">
                      {passwordValidation.errors.new_password1}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom01">
                    Confirmar palavra-passe nova
                  </Label>
                  <Input
                    name="new_password2"
                    placeholder="Confirmar palavra-passe"
                    type={showPasswords.new_password2 ? "text" : "password"}
                    className="form-control"
                    id="new_password2"
                    onChange={passwordValidation.handleChange}
                    onBlur={passwordValidation.handleBlur}
                    value={passwordValidation.values.new_password2 || ""}
                    invalid={
                      passwordValidation.touched.new_password2 &&
                      passwordValidation.errors.new_password2
                        ? true
                        : false
                    }
                  />
                  <span
                    onClick={() => togglePasswordVisibility("new_password2")}
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "37px",
                      cursor: "pointer",
                    }}
                  >
                    {showPasswords.new_password2 ? (
                      <i className="mdi mdi-eye-off"></i>
                    ) : (
                      <i className="mdi mdi-eye"></i>
                    )}
                  </span>
                  {passwordValidation.touched.new_password2 &&
                  passwordValidation.errors.new_password2 ? (
                    <FormFeedback type="invalid">
                      {passwordValidation.errors.new_password2}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={togglePassword}>
                Cancelar
              </Button>
              <Button color="danger" type="submit">
                Mudar palavra-passe
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </Container>
    </div>
  );
};

export default UsertSetting;
